
import {ValgtAvgiver} from './avgiver';

window['SVV.dinside.felles.avgiverV2'] =
	window['SVV.dinside.felles.avgiverV2'] || {};


export function hent() : Promise<ValgtAvgiver>{
	return window['SVV.dinside.felles.avgiverV2'].promise;
}

export function lagre(valgtAvgiver : Promise<ValgtAvgiver>) {
	 window['SVV.dinside.felles.avgiverV2'].promise = valgtAvgiver;
}